import { SalesChannelCampaignDetailPage } from "@/features/sales-channel-campaign/pages/SalesChannelCampaignDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/sales-channel-campaign/$id/detail",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["marketplace_campaigns.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCampaignDetailPage,
});
